import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
    } catch { /* server always returns 200 */ }
    setSubmitted(true);
    setLoading(false);
  };

  if (submitted) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-reset-cream px-4">
        <div className="w-full max-w-md text-center">
          <h1 className="font-serif text-2xl font-bold text-reset-brown mb-3">Check your email</h1>
          <p className="text-gray-600 text-sm mb-6">
            If that email is registered, a reset link is on its way. Check your spam folder if you don&apos;t see it.
          </p>
          <Link to="/auth/login" className="text-reset-terracotta hover:underline text-sm">
            Back to sign in
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-reset-cream px-4">
      <div className="w-full max-w-md">
        <h1 className="font-serif text-2xl font-bold text-reset-brown mb-1">Reset your password</h1>
        <p className="text-gray-500 text-sm mb-8">Enter your email and we&apos;ll send a reset link.</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-reset-brown mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-reset-terracotta"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-reset-terracotta text-white py-2 rounded-lg font-medium text-sm hover:opacity-90 disabled:opacity-50 transition"
          >
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>

        <p className="text-center text-sm text-gray-500 mt-6">
          <Link to="/auth/login" className="text-reset-terracotta hover:underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
